import { render, staticRenderFns } from "./Taskmanager.vue?vue&type=template&id=26ceeeb6"
import script from "./Taskmanager.vue?vue&type=script&lang=js"
export * from "./Taskmanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports